import React, { useState, useEffect, useRef } from "react";
import { Modal, Button, Row, Col, notification } from "antd";
import SignatureCanvas from "react-signature-canvas";

const SignPad = (props) => {
  const { showSignPad, setShowSignPad, signature, isModal, disabled } = props;
  const signPadRef = useRef(null);

  const [showImage, setShowImage] = useState(false);
  const [hasDrawn, setHasDrawn] = useState(false);

  useEffect(() => {
    if (signPadRef.current && signature !== null) {
      signPadRef.current.fromDataURL(signature);
    }
  }, [signPadRef.current]);

  useEffect(() => {
    setShowImage(signature == null ? false : true);
    setHasDrawn(signature == null ? false : true);
  }, [signature]);

  const isSignValid = () => {
    let fileSize = signPadRef.current.toDataURL();
    let base64str = fileSize.substr(22);
    let decoded = atob(base64str);
    console.log(decoded.length + "bytes");
    if (decoded.length <= 2500) {
      return false;
    } else {
      return true;
    }
  };

  const handleSignPadOk = () => {
    if (isModal !== false) {
      setShowSignPad(false);
    }
    if (showImage) {
      props.onSignPadOk(signature);
    } else {
      if (!isSignValid()) {
        return notification.error({
          message:
            "Sorry, your signature is too short to be valid. Please try drawing a valid signature with at least one character.",
        });
      } else {
        props.onSignPadOk(signPadRef.current.toDataURL());
      }
    }
  };

  const handleSignPadCancel = () => {
    setShowSignPad(false);
  };

  const handleSignPadReset = () => {
    if (!showImage) signPadRef.current.clear();
    props.onSignPadOk(null);
    setShowImage(false);
    setHasDrawn(false);
  };

  const styles = {
    canvas: {
      width: 300,
      height: 200,
      mindistance: 0,
      minwidth: 450,
      maxwidth: 450,
      id: "mySignature",
    },
    container: {
      width: "100%",
      height: "100%",
      top: "10%",
      left: "10%",
    },
    sigContainer: {
      width: "500",
      height: "250",
      margin: "0 auto",
      backgroundColor: "#fff",
      borderStyle: "dotted",
    },
  };

  return (
    <>
      {isModal === false ? (
        <>
          {showSignPad ? (
            <>
              <Row align="middle" gutter="">
                <Col
                  xs={24}
                  md={{ span: 7, offset: 8 }}
                  style={{ borderStyle: "dotted" }}
                >
                  {showImage ? (
                    <img
                      src={signature}
                      style={{ ...styles.canvas, ...{ width: "100%" } }}
                    />
                  ) : (
                    <>
                      <SignatureCanvas
                        canvasProps={styles.canvas}
                        ref={signPadRef}
                        onBegin={() => {
                          if (disabled === true) {
                            signPadRef.current.off();
                          }
                        }}
                        onEnd={() => {
                          handleSignPadOk();
                        }}
                      />
                    </>
                  )}
                </Col>
                {!showImage ? (
                  <Col
                    xs={24}
                    md={{ span: 7, offset: 8 }}
                    style={{ paddingTop: "10px" }}
                  >
                    <Button
                      key="reset"
                      onClick={handleSignPadReset}
                      type="danger"
                    >
                      Reset
                    </Button>
                  </Col>
                ) : null}
              </Row>
            </>
          ) : (
            <></>
          )}
        </>
      ) : (
        <>
          <Modal
            title="Electronic Signature"
            visible={showSignPad}
            closable={false}
            width={350}
            footer={[
              <Button key="back" onClick={handleSignPadCancel} type="danger">
                Cancel
              </Button>,
              <Button key="reset" onClick={handleSignPadReset} type="danger">
                Reset
              </Button>,
              <Button
                key="submit"
                disabled={!hasDrawn}
                type="primary"
                onClick={handleSignPadOk}
                danger
              >
                Submit
              </Button>,
            ]}
          >
            <Row>
              <Col>
                <div style={styles.container}>
                  <div style={styles.sigContainer}>
                    {showImage ? (
                      <img src={signature} style={styles.canvas} />
                    ) : (
                      <SignatureCanvas
                        canvasProps={styles.canvas}
                        ref={signPadRef}
                        // onBegin={() => {
                        //   setHasDrawn(true);
                        // }}
                        onEnd={() => {
                          if (!isSignValid()) {
                            return notification.error({
                              message:
                                "Sorry, your signature is too short to be valid. Please try drawing a valid signature with at least one character.",
                            });
                          } else {
                            setHasDrawn(true);
                          }
                        }}
                      />
                    )}
                  </div>
                </div>
              </Col>
            </Row>
          </Modal>
        </>
      )}
    </>
  );
};
export default SignPad;
